import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowMissingPartners = createSelector(
  [selectWelcomeFlowState],
  (state) => state.MissingAssignment
)
